/**
 * Advisors Show List script
 */
class FinHub_AdvisorsShowList {
    constructor() {
        this.initState();
    }

    initState() {
        this.advisorArchivePage = $('.advisor-archive');
        this.advisorArchiveForm = this.advisorArchivePage.find('#show-form-form');
        this.dataClick = this.advisorArchiveForm.attr('data-click');
        this.advisorArchiveFormSearchBtn = this.advisorArchiveForm.find('#search-advisers-button');
        this.advisorArchiveList = this.advisorArchivePage.find('#search-advisers-list');
        this.searchAdvisor = this.advisorArchiveForm.find('#search-advisor');
        this.searchAdvisorCity = this.advisorArchiveForm.find('#search-advisor-city');
        this.searchBottomBar = this.advisorArchiveForm.find('.bottom');
        this.searchAdvisorOnline = this.advisorArchiveForm.find('input[name="only_online"]');
        this.searchAdvisorSort = this.advisorArchiveForm.find('#sort-select');
        this.advisorArchiveRange = this.advisorArchivePage.find('.range');
        this.advisorArchiveRangeInput = this.advisorArchiveRange.find('#range-input');
        this.ratingOutput = this.advisorArchiveRange.find('.range-output');
        this.advisorArchiveRangeMinText = this.advisorArchiveRange.find('.min span');
        this.advisorArchiveRangeMaxText = this.advisorArchiveRange.find('.max span');
        this.advisorArchiveCityDesc = this.advisorArchivePage.find('#search-advisers-city-desc');

        if (this.advisorArchiveForm.length) {
            this.initEvents();
        }
    }

    getLoadedAdvisersIds() {
        let ids = [];
        $('.block-advisers__item').each((i, item) => {
            let id = $(item).attr('data-adviser-id');
            id = parseInt(id, 10);
            ids.push(id);
        });

        return ids;
    }

    initEvents() {
        this.advisorArchiveFormSearchBtn.on('click', (e) => {
            e.preventDefault();
            this.searchAdvisorOnline.prop( "checked", false );
            $('.advisor-map .map .map-overlay-button').removeClass('is-hidden');

            setTimeout(() => {
                this.getAdviserResults();
            }, 0);
        });

        if (this.dataClick == '1') {
            this.searchAdvisorOnline.prop( "checked", false );

            setTimeout(() => {
                this.getAdviserResults();
            }, 0);
        }
    }

    getAdviserResults () {
        this.advisorArchiveList.addClass('is-loading');

        $.ajax({
            url: $('#show-form-form').attr('action'),
            type: 'POST',
            dataType: 'json',
            data: jQuery.param({
                search: this.searchAdvisor.val(),
                city: this.searchAdvisorCity.val(),
                only_online: this.searchAdvisorOnline.prop('checked') ? 1 : 0,
                sort: this.searchAdvisorSort.val()
            })
        }).done((response) => {
            this.advisorArchiveList.removeClass('is-loading');
            let uniqid = +new Date();
            this.advisorArchiveList.html(response.html + '<div id="loader-' + uniqid + '"></div>')

            if (response.city_html) {
                this.advisorArchiveCityDesc.html(response.city_html)
            }

            if (this.searchBottomBar.hasClass('hidden')) {
                this.searchBottomBar.removeClass('hidden');
            }

            this.advisorArchiveRangeInput.attr('min', parseFloat(response.min_radius));
            this.advisorArchiveRangeInput.attr('max', parseFloat(response.max_radius));
            this.advisorArchiveRangeInput.val(parseFloat(response.max_radius));
            this.advisorArchiveRangeMinText.text(response.min_radius);
            this.advisorArchiveRangeMaxText.text(response.max_radius);
            this.ratingOutput.text('');
            this.ratingOutput.css('left', 'calc(50% - 12px)');

            this.initRangeSlider();
            this.initCheckOnlyOnline();
            this.initChangeSelect();

            this.debouncedGetReloadAdviserResults = this.debounce(() => this.getReloadAdviserResults(), 750);

            setTimeout(() => {
                this.infinityScroll(uniqid, response.max_items);
            }, 0);
        }).fail((response) => {
            this.advisorArchiveList.removeClass('is-loading');
        });
    }

    getReloadAdviserResults () {
        this.advisorArchiveList.addClass('is-loading');

        $.ajax({
            url: $('#show-form-form').attr('action'),
            type: 'POST',
            dataType: 'json',
            data: jQuery.param({
                search: this.searchAdvisor.val(),
                city: this.searchAdvisorCity.val(),
                only_online: this.searchAdvisorOnline.prop('checked') ? 1 : 0,
                sort: this.searchAdvisorSort.val(),
                radius: this.advisorArchiveRangeInput.val()
            })
        }).done((response) => {
            this.advisorArchiveList.removeClass('is-loading');
            let uniqid = +new Date();
            this.advisorArchiveList.html(response.html + '<div id="loader-' + uniqid + '"></div>')

            if (response.city_html) {
                this.advisorArchiveCityDesc.html(response.city_html)
            }

            if (this.searchBottomBar.hasClass('hidden')) {
                this.searchBottomBar.removeClass('hidden');
            }

            setTimeout(() => {
                this.infinityScroll(uniqid, response.max_items);
            }, 0);
        }).fail((response) => {
            this.advisorArchiveList.removeClass('is-loading');
        });
    }

    infinityScroll(uniqid, maxItems) {
        let loadedItemsCount = this.advisorArchiveList.find('.block-advisers__item').length;

        if (loadedItemsCount >= maxItems) {
            return;
        }

        let observedElement = $('#loader-' + uniqid);
        let observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entries[0].intersectionRatio === 0) {
                    return;
                }

                observer.unobserve(observedElement[0]);
                observedElement.addClass('is-loading');
                $.ajax({
                    url: this.advisorArchiveForm.attr('action'),
                    type: 'POST',
                    dataType: 'json',
                    data: jQuery.param({
                        search: this.searchAdvisor.val(),
                        city: this.searchAdvisorCity.val(),
                        only_online: this.searchAdvisorOnline.prop('checked') ? 1 : 0,
                        sort: this.searchAdvisorSort.val(),
                        exclude: this.getLoadedAdvisersIds(),
                        radius: this.advisorArchiveRangeInput.val()
                    })
                }).done((response) => {
                    observedElement.removeClass('is-loading');

                    if (response.html) {
                        let newUniqid = +new Date();
                        this.advisorArchiveList.append($(response.html));

                        setTimeout(() => {
                            window.updateAdvisorsMap();
                            this.advisorArchiveList.append($('<div id="loader-' + newUniqid + '"></div>'));
                            this.infinityScroll(newUniqid, response.max_items);
                        }, 0);
                    }
                }).fail((response) => {
                    console.log(response);
                });
            });
        }, {
            threshold: [0.1, 0.25, 0.5, 0.75, 1]
        });

        observer.observe(observedElement[0]);
    }

    initRangeSlider () {
        this.advisorArchiveRangeInput.unbind('input');
        this.advisorArchiveRangeInput.on('input', () => {
            let ratingRangeValue = this.advisorArchiveRangeInput.val();
            let ratingMax = this.advisorArchiveRangeInput.attr('max');
            let ratingMin = this.advisorArchiveRangeInput.attr('min');
            let reatingOutputPosX = ((100 * (ratingRangeValue - ratingMin)) / (ratingMax - ratingMin));

            this.ratingOutput.text(ratingRangeValue);
            this.ratingOutput.css('left', 'calc(' + reatingOutputPosX + '% - 15px)');

            setTimeout(() => {
                this.debouncedGetReloadAdviserResults();
            }, 0);
        });
    }

    initCheckOnlyOnline () {
        this.searchAdvisorOnline.unbind('input');
        this.searchAdvisorOnline.on('input', () => {
            setTimeout(() => {
                this.debouncedGetReloadAdviserResults();
            }, 0);
        });
    }

    initChangeSelect () {
        this.searchAdvisorSort.unbind('change');
        this.searchAdvisorSort.on('change', () => {
            setTimeout(() => {
                this.debouncedGetReloadAdviserResults();
            }, 0);
        });
    }

    debounce(func, timeout = 500) {
        let timer;

        return (...args) => {
          clearTimeout(timer);
          timer = setTimeout(() => { func.apply(this, args); }, timeout);
        };
    }
}
